import { v4 as uuidv4 } from 'uuid';

export function copyToClipboard(element) {

    if (!element)
        return Promise.reject();

    const textToCopy = element.innerText;

    if (navigator.clipboard && window.isSecureContext) {

        // navigator clipboard api method'
        return navigator.clipboard.writeText(textToCopy);
    }
    else {

        // text area method
        let textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        // make the textarea out of viewport
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise((res, rej) => {
            // here the magic happens
            document.execCommand('copy') ? res() : rej();
            textArea.remove();
        });
    }
};

export function generateUniqueString(company) {
    // Remove leading/trailing spaces from company
    company = company.trim();

    // Check if company is empty or not in English
    const isEnglishCompany = /^[A-Za-z\s]*$/.test(company);
    if (company === '' || !isEnglishCompany) {
        company = uuidv4().replace(/-/g, '').substring(0, 25);
        company = company.substring(0, 16);
    } else {
        // Trim company to maximum 16 characters
        company = company.substring(0, 16);
    }

    // Generate timestamp in the format yyyymmddThhmmssZ in UTC
    const now = new Date();
    const year = now.getUTCFullYear();
    const month = String(now.getUTCMonth() + 1).padStart(2, '0');
    const day = String(now.getUTCDate()).padStart(2, '0');
    const hours = String(now.getUTCHours()).padStart(2, '0');
    const minutes = String(now.getUTCMinutes()).padStart(2, '0');
    const seconds = String(now.getUTCSeconds()).padStart(2, '0');
    const timestamp = `${year}${month}${day}T${hours}${minutes}${seconds}Z`;

    // Combine company and timestamp
    let result = company + '-' + timestamp;

    // Trim result to maximum 32 characters
    result = result.substring(0, 32);
    
    return result;
}